/** @flow */
import * as React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import IncreaseDecreasePercent from 'common/components/IncreaseDecreasePercent';
import HourlyMetricsGraph from '../../components/HourlyMetricsGraph';
import { hourlyMetricsType, calculateMetricVariation } from '../../domain/DashboardData';

const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  padding-top: ${({ theme }) => theme.metrics.margin}px;
`;

const Content = styled.div`
  display: flex;
  height: 90%;
`;

const HeaderElement = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 18px;
  margin-bottom: ${({ theme }) => theme.metrics.margin}px; 
  margin-top: ${({ theme }) => theme.metrics.smallMargin}px; 
  align-items: start;
`;

type Props = {
  data: Object;
  title: string;
  metricType: hourlyMetricsType;
  typeText: string;
  t: any;
};

function HourlyMetricPrintingElement({ data, title, metricType, typeText, t }: Props) {
  return (
    <React.Fragment>
      <Header>
        {metricType === 'listeningTime' &&
          <HeaderElement>{typeText} ({t('hours')})</HeaderElement>
        }
        {metricType === 'reach' &&
          <HeaderElement>{typeText}</HeaderElement>
        }
        <HeaderElement>{title}</HeaderElement>
        <HeaderElement>
          <IncreaseDecreasePercent
            percent={metricType === 'reach' ? calculateMetricVariation(data.comparedReachByTimeInterval) : calculateMetricVariation(data.comparedListeningTimeByTimeInterval)}
          />
        </HeaderElement>
      </Header>
      <Content>
        <HourlyMetricsGraph
          reach={data.comparedReachByTimeInterval}
          listeningTime={data.comparedListeningTimeByTimeInterval}
          type={metricType}
          hideInteraction
        />
      </Content>
    </React.Fragment>
  );
}

export default translate('dashboard')(HourlyMetricPrintingElement);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/printing/components/HourlyMetricPrintingElement.js